import React, { useState } from 'react';
import { clinicService } from '../../services/api';

// Import icons
import { ReactComponent as DownloadIcon } from '../../assets/download.svg';

const ConfigExportSection = ({ clinicId }) => {
  const [isExporting, setIsExporting] = useState(false);
  const [exportError, setExportError] = useState(null);

  const handleExport = async () => {
    try {
      setIsExporting(true);
      setExportError(null);

      const response = await clinicService.exportClinicConfiguration(clinicId);

      // Create a blob from the data - using response directly instead of response.data
      const blob = new Blob([JSON.stringify(response, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);

      // Create and trigger download
      const link = document.createElement('a');
      link.href = url;
      link.download = `clinic_${clinicId}_config.json`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error exporting clinic configuration:', error);
      setExportError('Failed to export clinic configuration. Please try again.');
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="bg-gray-50 p-6 rounded-lg">
      <h3 className="text-lg font-semibold text-gray-700 mb-6">Clinic Configuration Export</h3>

      <div className="bg-white p-6 rounded-lg shadow">
        <h4 className="text-md font-semibold mb-4 flex items-center">
          <DownloadIcon className="h-5 w-5 mr-2 text-gray-600" />
          Export Configuration
        </h4>
        <p className="text-gray-600 mb-4">
          Export the current clinic configuration as a JSON file. This includes all settings,
          doctors, schedules, knowledge base entries, and other related data.
        </p>

        {exportError && (
          <div className="mb-4 p-3 bg-red-100 text-red-700 rounded">
            {exportError}
          </div>
        )}

        <button
          onClick={handleExport}
          disabled={isExporting}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-blue-300 flex items-center"
        >
          <DownloadIcon className="h-4 w-4 mr-2" />
          {isExporting ? 'Exporting...' : 'Export Clinic Configuration'}
        </button>
      </div>
    </div>
  );
};

export default ConfigExportSection;
